<template>
  <main class="l-main p-register">
    <div class="l-block">
      <PaymentLocalNav />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>クレジットカード情報を入力してください。</h1>
        </div>
        <FormRegisterCard :params="params" @submit="submit" />
      </div>
    </div>
  </main>
</template>

<script>
import FormRegisterCard from '@/components/config/FormRegisterCard';
import Progress from '@/components/Progress';
import PaymentLocalNav from '@/components/payment/PaymentLocalNav';
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    FormRegisterCard,
    Progress,
    PaymentLocalNav,
    TitleRegister
  },
  data() {
    return {
      params: Object.assign({}, this.$store.state.payment.params),
      progress: [
        {
          label: 'プランの選択'
        },
        {
          label: 'お支払い方法の選択'
        },
        {
          current: true,
          label: 'カード情報の入力'
        }
      ]
    };
  },
  computed: {
    isAgent() {
      return this.$store.getters['user/isAgent'];
    }
  },
  created() {
    if (!this.params.planId) {
      this.$router.push({ name: 'paymentPlan' });
    }
    // 代理店ではない場合は、お支払い方法の選択のステップがなくなる
    if (!this.isAgent) {
      this.progress.splice(1, 1);
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('payment/reset');
      this.$store.dispatch('user/getPlan').finally(() => {
        this.$router.push({ name: 'projects' });
      });
    }
  }
};
</script>
